<template>
  <div>
    <vs-card id="vendor-table-loading" class="vs-con-loading__container">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <VendorTable
            :data="data"
            @search="search"
            @loadMore="loadMore"
            @showDetails="showDetails"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VendorTable from './components/VendorTable.vue'
import request from './request'
import loading from '@/mixins/Loading'
export default {
  components: {
    VendorTable,
  },
  data() {
    return {
      data: [],
      params: {
        lastPage: 1,
        page: 1,
        search: '',
        sortBy: ['Vendors.VendorName'],
        sort: ['ASC'],
      },
    }
  },
  mixins: [loading],
  methods: {
    getVendors() {
      let payload = { ...this.params }
      if (payload.search == '') {
        delete payload.search
      }
      request
        .getVendors(payload)
        .then((response) => {
          if (this.params.page === 1) {
            this.data = [...response.data.vendors.data]
          } else {
            this.data = [...this.data, ...response.data.vendors.data]
          }
          this.params.lastPage = response.data.vendors.last_page
        })
        .catch((response) => {
          this.showValidationErrors(response)
        })
    },
    loadMore() {
      if (this.params.page >= this.params.lastPage) {
        return
      }
      this.params.page++
      this.getVendors()
    },
    search(event = '') {
      this.params.search = event
      this.params.page = 1
      this.getVendors()
    },
    showDetails(id) {
      this.$router.push({
        name: 'vendors-detail',
        params: {
          id: id,
        },
      })
    },
  },
  mounted() {
    this.getVendors()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('vendor-table-loading')
      } else {
        this.closeLoading('vendor-table-loading')
      }
    },
  },
}
</script>

<style>
</style>